import {
  FETCH_ACCOUNT_USER_INIT,
  FETCH_ACCOUNT_USER_SUCCESS,
  FETCH_ACCOUNT_USER_FAILURE,
  FETCH_ACCOUNT_USER_COUNT_INIT,
  FETCH_ACCOUNT_USER_COUNT_SUCCESS,
  FETCH_ACCOUNT_USER_COUNT_FAILURE,
  FETCH_ACCOUNT_USER_ROLL_INIT,
  FETCH_ACCOUNT_USER_ROLL_SUCCESS,
  FETCH_ACCOUNT_USER_ROLL_FAILURE,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS,
  FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE,
  FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_RESET,
  FETCH_ACCOUNT_USER_NO_LOADING_INIT,
  FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS,
  FETCH_ACCOUNT_USER_NO_LOADING_FAILURE,
  SAVE_ACCOUNT_USER_INIT,
  SAVE_ACCOUNT_USER_SUCCESS,
  SAVE_ACCOUNT_USER_FAILURE,
  UPDATE_ACCOUNT_USER_INIT,
  UPDATE_ACCOUNT_USER_SUCCESS,
  UPDATE_ACCOUNT_USER_FAILURE,
  UPDATE_ACCOUNT_USER_PASS_INIT,
  UPDATE_ACCOUNT_USER_PASS_SUCCESS,
  UPDATE_ACCOUNT_USER_PASS_FAILURE,
  DELETE_ACCOUNT_USER_INIT,
  DELETE_ACCOUNT_USER_SUCCESS,
  DELETE_ACCOUNT_USER_FAILURE,
  ACTIVE_ACCOUNT_USER_INIT,
  ACTIVE_ACCOUNT_USER_SUCCESS,
  ACTIVE_ACCOUNT_USER_FAILURE,
  RESET_MODAL,
  RESET_ACCOUNT_USER,
  FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS,
  FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE,
  FETCH_DOWNLOAD_ACCOUNT_USER_INIT,
  FETCH_UPLOAD_ACCOUNT_USER_SUCCESS,
  FETCH_UPLOAD_ACCOUNT_USER_FAILURE,
  FETCH_UPLOAD_ACCOUNT_USER_INIT,
  RESET_MODAL_FILE
} from './types';
import API from './api';

export function resetModalFileUserAccount() {
  return {
    type: RESET_MODAL_FILE
  };
}

export function resetModalUser() {
  return {
    type: RESET_MODAL
  };
}

export function resetAccountUser() {
  return {
    type: RESET_ACCOUNT_USER
  };
}

/* Account User get */

function fetchApiSuccess(data) {
  return {
    type: FETCH_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function fetchApiFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_FAILURE,
    payload: error
  };
}

function fetchApiInit() {
  return {
    type: FETCH_ACCOUNT_USER_INIT
  };
}

export function fetchAccountUserApi(group, tags) {
  return async dispatch => {
    dispatch(fetchApiInit());
    try {
      let data = await API.data.getAll(group, tags);
      dispatch(fetchApiSuccess(data));
    } catch (error) {
      dispatch(fetchApiFailure(error));
    }
  };
}

/* Account User no loading */

function fetchApiNoLoadingSuccess(data, concat) {
  return {
    type: FETCH_ACCOUNT_USER_NO_LOADING_SUCCESS,
    payload: data,
    concat: concat
  };
}

function fetchApiNoLoadingFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_NO_LOADING_FAILURE,
    payload: error
  };
}

function fetchApiNoLoadingInit() {
  return {
    type: FETCH_ACCOUNT_USER_NO_LOADING_INIT
  };
}

export function fetchAccountUserNoLoadingApi(obj) {
  return async dispatch => {
    dispatch(fetchApiNoLoadingInit());
    try {
      let data = await API.data.getAll(obj);
      dispatch(fetchApiNoLoadingSuccess(data, obj.concat));
    } catch (error) {
      dispatch(fetchApiNoLoadingFailure(error));
    }
  };
}

/* User COUNT */

function fetchApiCountSuccess(data) {
  return {
    type: FETCH_ACCOUNT_USER_COUNT_SUCCESS,
    payload: data
  };
}

function fetchApiCountFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_COUNT_FAILURE,
    payload: error
  };
}

function fetchApiCountInit() {
  return {
    type: FETCH_ACCOUNT_USER_COUNT_INIT
  };
}

export function fetchAccountUserCountApi(obj) {
  return async dispatch => {
    dispatch(fetchApiCountInit());
    try {
      let data = await API.data.getCount(obj);
      dispatch(fetchApiCountSuccess(data));
    } catch (error) {
      dispatch(fetchApiCountFailure(error));
    }
  };
}

/* User ROll */

function fetchApiRollSuccess(data) {
  return {
    type: FETCH_ACCOUNT_USER_ROLL_SUCCESS,
    payload: data
  };
}

function fetchApiRollFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_ROLL_FAILURE,
    payload: error
  };
}

function fetchApiRollInit() {
  return {
    type: FETCH_ACCOUNT_USER_ROLL_INIT
  };
}

export function fetchAccountUserRollApi(obj) {
  return async dispatch => {
    dispatch(fetchApiRollInit());
    try {
      let data = await API.data.getRoll(obj);
      dispatch(fetchApiRollSuccess(data));
    } catch (error) {
      dispatch(fetchApiRollFailure(error));
    }
  };
}

/* User options to create user */

function fetchOptionsToCreateUserSuccess(data) {
  return {
    type: FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_SUCCESS,
    payload: data
  };
}

function fetchOptionsToCreateUserFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_FAILURE,
    payload: error
  };
}

function fetchOptionsToCreateUserInit() {
  return {
    type: FETCH_ACCOUNT_USER_OPTIONS_TO_CREATE_USER_INIT
  };
}

export function fetchOptionsToCreateUser() {
  return async dispatch => {
    dispatch(fetchOptionsToCreateUserInit());
    try {
      let data = await API.data.getOptionsToCreateUser();
      dispatch(fetchOptionsToCreateUserSuccess(data));
    } catch (error) {
      dispatch(fetchOptionsToCreateUserFailure(error));
    }
  };
}

/* get user to edit */

function fetchUserToEditSuccess(data) {
  return {
    type: FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_SUCCESS,
    payload: data
  };
}

function fetchUserToEditFailure(error) {
  return {
    type: FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_FAILURE,
    payload: error
  };
}

function fetchUserToEditInit() {
  return {
    type: FETCH_ACCOUNT_USER_GET_USER_TO_EDIT_INIT
  };
}

export function fetchUserToEdit(params) {
  return async dispatch => {
    dispatch(fetchUserToEditInit());
    try {
      let data = await API.data.getUserToEdit(params);
      dispatch(fetchUserToEditSuccess(data));
    } catch (error) {
      dispatch(fetchUserToEditFailure(error));
    }
  };
}

/* User Save (Async) */

function saveApiSuccess(data) {
  return {
    type: SAVE_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function saveApiFailure(error) {
  return {
    type: SAVE_ACCOUNT_USER_FAILURE,
    errorSave: error
  };
}

function saveApiInit() {
  return {
    type: SAVE_ACCOUNT_USER_INIT
  };
}

export function handleUser(data) {
  return async dispatch => {
    dispatch(saveApiInit());
    try {
      const resp = await API.data.handleUser(data);
      return dispatch(saveApiSuccess(resp));
    } catch (error) {
      return dispatch(saveApiFailure(error));
    }
  };
}

/* Update User (Async) */

function updateApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function updateApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_USER_FAILURE,
    errorupdate: error
  };
}

function updateApiInit() {
  return {
    type: UPDATE_ACCOUNT_USER_INIT
  };
}

export function handleUpdateUser(data) {
  return async dispatch => {
    dispatch(updateApiInit());
    try {
      const resp = await API.data.handleUpdateUser(data);
      return dispatch(updateApiSuccess(resp));
    } catch (error) {
      return dispatch(updateApiFailure(error));
    }
  };
}

/* Update User Pass (Async) */

function updatePassApiSuccess(data) {
  return {
    type: UPDATE_ACCOUNT_USER_PASS_SUCCESS,
    payload: data
  };
}

function updatePassApiFailure(error) {
  return {
    type: UPDATE_ACCOUNT_USER_PASS_FAILURE,
    errorupdate: error
  };
}

function updatePassApiInit() {
  return {
    type: UPDATE_ACCOUNT_USER_PASS_INIT
  };
}

export function handleUpdateUserPass(data) {
  return async dispatch => {
    dispatch(updatePassApiInit());
    try {
      const resp = await API.data.handleUpdateUserPass(data);
      return dispatch(updatePassApiSuccess(resp));
    } catch (error) {
      return dispatch(updatePassApiFailure(error));
    }
  };
}

/* user Delete (Async) */

function deleteApiSuccess(data) {
  return {
    type: DELETE_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function deleteApiFailure(error) {
  return {
    type: DELETE_ACCOUNT_USER_FAILURE,
    errordelete: error
  };
}

function deleteApiInit() {
  return {
    type: DELETE_ACCOUNT_USER_INIT
  };
}

export function handleDeleteUser(data) {
  return async dispatch => {
    dispatch(deleteApiInit());
    try {
      const resp = await API.data.handleDeleteUser(data);
      return dispatch(deleteApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteApiFailure(error));
    }
  };
}

/* Active user (Async) */

function activeApiSuccess(data) {
  return {
    type: ACTIVE_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function activeApiFailure(error) {
  return {
    type: ACTIVE_ACCOUNT_USER_FAILURE,
    errordelete: error
  };
}

function activeApiInit() {
  return {
    type: ACTIVE_ACCOUNT_USER_INIT
  };
}

export function handleActiveUser(data) {
  return async dispatch => {
    dispatch(activeApiInit());
    try {
      const resp = await API.data.handleActiveUser(data);
      return dispatch(activeApiSuccess(resp));
    } catch (error) {
      return dispatch(activeApiFailure(error));
    }
  };
}

/* get download file */

function fetchUploadApiSuccess(data) {
  return {
    type: FETCH_UPLOAD_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function fetchUploadApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_UPLOAD_ACCOUNT_USER_FAILURE,
    payload: error
  };
}

function fetchUploadApiInit() {
  return {
    type: FETCH_UPLOAD_ACCOUNT_USER_INIT
  };
}

export function fetchAccountUserUploadApi(action) {
  return async dispatch => {
    dispatch(fetchUploadApiInit());
    try {
      let resp;

      switch (action) {
        case 'import-users':
          resp = await API.data.handleUserUpload();
          break;
        case 'associate-users':
          resp = await API.data.handleUserUploadAssociateUsers();
          break;
        default:
          throw new Error(`Unsupported action: ${action}`);
      }

      dispatch(fetchUploadApiSuccess(resp));
    } catch (error) {
      dispatch(fetchUploadApiFailure(error));
    }
  };
}

/* get download file */

function fetchDownloadApiSuccess(data) {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_USER_SUCCESS,
    payload: data
  };
}

function fetchDownloadApiFailure(error) {
  console.log(error);
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_USER_FAILURE,
    payload: error
  };
}

function fetchDownloadApiInit() {
  return {
    type: FETCH_DOWNLOAD_ACCOUNT_USER_INIT
  };
}

export function fetchAccountUserDownloadApi(action) {
  return async dispatch => {
    dispatch(fetchDownloadApiInit());
    try {
      let resp;

      switch (action) {
        case 'import-users':
          resp = await API.data.handleUserDownload();
          break;
        case 'associate-users':
          resp = await API.data.handleUserDownloadAssociateUsers();
          break;
        default:
          throw new Error(`Unsupported action: ${action}`);
      }

      dispatch(fetchDownloadApiSuccess(resp));
    } catch (error) {
      dispatch(fetchDownloadApiFailure(error));
    }
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/account_user/index.js